<template>
  <div id='bbncIndex'>
    <Header :searchcategories="searchcategories" :fburl="fburl" :instagramurl="instagramurl"></Header>
    <Navbar ref="navbar" :navitems="navitems"></Navbar>

    <scrollHeader ref="scrollHeader" v-bind:class="{'d-none':setScrollHeader}" :searchcategories="searchcategories" :fburl="fburl" :instagramurl="instagramurl" :navitems="navitems"></scrollHeader>
    
    <div id="body">
        <div class="container">
            <div class="row"> 
                <div class="col-lg-9 col-md-9 col-sm-12 col-12">
                    <div id="leftbody" class="p-0">
                        <slot name="body"> </slot>
                    </div>
                </div>
                <Rightbody class="col-lg-3 col-md-3 col-sm-12 col-12" :fburl="fburl" :instagramurl="instagramurl">
                    <template slot="sidebar">

                        <slot name="sidebar">
                            
                        </slot>
                    
                    </template>
                </Rightbody>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// import "./css/bbnc.css";

import Header from "./layouts/header.vue";
import scrollHeader from "./layouts/onscroll-header.vue";

export default {
    name: 'bbnc',
    props:{
        // Header
        'searchcategories' : {
            type: Array
        },
        'fburl' : {
            type: String
        },
        'instagramurl' : {
            type: String
        },

        // Navbar
        'navitems' : {
            type: Array
        },
    },
    components: {
        Header,
        scrollHeader,
    },
    data(){
    return{
        setScrollHeader:true,
    }
  },
  methods:{
     handleScroll: function () {
            let navbarOffset=this.$refs.navbar.$el.offsetTop;
              window.pageYOffset > navbarOffset? this.setScrollHeader=false: this.setScrollHeader=true;
            }
  },
    created: function () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed: function () {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script> 

<style scoped>
   
    #body{
        padding-top:30px;
        margin-bottom:50px;
    }

    .rightbody{
        display: inline-grid;
    }
    .leftbody{
        display: -webkit-inline-box;
    } 

    ul.list-unstyled{
        margin-bottom: 0px !important;
    }
    @media (max-width:992px){
          #body .container{
              padding: 0px 15px !important;
              max-width: 100% !important;
          }
    } 
 
    @media (max-width:768px){
        
    }


    @media (max-width:576px){
          #body .container{
              padding: 0px 5px !important;
              max-width: 100% !important;
          }
    }

</style>




// WEBPACK FOOTER //
// src/components/bbnc/bbnc.vue